import axios from "axios";
import React from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";

export function ProposalReopen({resHandler, errHandler, loading, rootUrl, disabled}: {
    resHandler: (e) => void,
    errHandler: (e) => void,
    loading: boolean,
    rootUrl: string,
    disabled: boolean
}) {

    const [container, setContainer] = React.useState(null);

    return (
        <>
        <div ref={setContainer} className='position-relative'>
        <AlertDialog.Root>
            <AlertDialog.Trigger className='btn button_warning' disabled={loading || disabled}>
                Reopen Proposal
            </AlertDialog.Trigger>
            <AlertDialog.Portal container={container}>
                <AlertDialog.Overlay className={'bg-opacity-25 bg-black position-fixed top-0 bottom-0 start-0 end-0'} style={{zIndex: '99999999999999999999999999999999'}}/>
                <AlertDialog.Content
                    className={'bg-white position-absolute mt-3 pt-2 pb-2 ps-3 pe-3 shadow-lg bottom-0 end-0'}
                    // className={'bg-white position-fixed top-50 mt-3 end-0 pt-2 pb-2 ps-3 pe-3 translate-middle shadow-sm'}
                    style={{width: '30em', zIndex: '9999999999999999999999999999999999', maxHeight: '100vh'}}>
                    <AlertDialog.Title>Are you sure?</AlertDialog.Title>
                    <AlertDialog.Description>Reopening the Proposal will clear all Reviews and Approvals</AlertDialog.Description>
                    <div className='d-flex justify-content-end p-0 gap-2'>
                        <AlertDialog.Cancel className={'button'}>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action className={'button_warning'}
                                            onClick={() => axios.get(`${rootUrl}/reopen`).then(resHandler).catch(errHandler)}
                        >Reopen Proposal</AlertDialog.Action>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
        </div>
        </>
    )
}